/* ================================================================
   8TH SIN — COLLECTION GRID JS  (simplified — no quick view)
   Sort pills · cart count on load
   ================================================================ */

(function () {
  'use strict';

  /* ── SORT PILLS ── */
  document.querySelectorAll('.cg-sort-pill').forEach(pill => {
    pill.addEventListener('click', e => {
      e.preventDefault();
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', pill.dataset.sort);
      window.location.href = url.toString();
    });
  });

  /* ── CART COUNT ON LOAD ── */
  fetch('/cart.js')
    .then(r => r.json())
    .then(d => {
      document.querySelectorAll('.cart-count, .cv-cart-count').forEach(el => {
        el.textContent = d.item_count;
      });
    })
    .catch(() => {});

})();
